<script setup>
	import { ref, onMounted } from 'vue'
  	import MediaModal from "@/components/home/MediaModal.vue";

	//reactive field proxies
	const showMediaModal = ref(false)

	//reactive field proxies
	const title = ref('null')
	const poster = ref('null')
	const source = ref('null')
	const description = ref('null')
	const indicator = ref('null')

	//Methods
	async function getText(file) {
		let x = await fetch(file);
		let y = await x.text();
		let cardObj = JSON.parse(y);

		title.value = cardObj.title
		source.value = import.meta.env.VITE_BASE_URL + cardObj.filePath
		poster.value = import.meta.env.VITE_BASE_URL + cardObj.poster
		//description.value = cardObj.description
		//indicator.value = encodeURIComponent(cardObj.indicator)
	}
	
  	function closeMediaModal() {
		showMediaModal.value = false
	}
  	function openMediaModal() {
		//if(isSmallScreen) toggleMenu()
		showMediaModal.value = true
	}
	//initial method run on page load
    let url = import.meta.env.VITE_BASE_URL + "/json/videoCardLongIntro.json"
    getText(url);
</script>

<template>
	<section class="about-section">
		<MediaModal :isOpen="showMediaModal" :source="source" :poster="poster" @closeMediaModal="closeMediaModal" />
		<div class="intro-about">
			<div class="section-header">
				About Indicators Explorer
			</div>
			<div class="section-description">
				As global competition in the fields of science and engineering (S&E) continues to increase, U.S. policymakers and other experts need fast, reliable access to information about national and international trends in S&E resources and activities. The Indicators Explorer is a data visualization tool that offers the ability to quickly and easily access, manipulate, visualize, and share information that represents national and global trends in the S&E enterprise.
			</div>

			<div class="action-bttn">
				<router-link class="btn-primary" :to="{ name: 'OverviewView' }">Browse All Indicators</router-link>
			</div>
		</div>

		<div class="intro-video-block">
			<img class="card-image" :src="poster" alt="Sample chart" width="100%"/>
			<div class="video-start">
				<span class="video-icon" @click="openMediaModal" :title="title"><i class="fa fa-regular fa-circle-play"></i></span>
			</div>
		</div>
		
	</section>
</template>

<style scoped>
.about-section {
	display: flex;
	padding: var(--spacing-7xl, 6rem) var(--spacing-5xl, 4rem);
	flex-direction: row;
	align-items: flex-start;
	gap: var(--spacing-2xl, 2rem);
	align-self: stretch;	

	background: var(--surface-color-Tertiary);

	/*flex-direction: row-reverse; /* Puts the second item (image-wrapper) on the right */
	/*align-items: center; /* Vertically centers items */
	justify-content: space-between; /* Spreads out content and image */
	width: 100%;
	/*justify-content: space-evenly;*/
	flex-wrap: wrap;
	gap: 0.625rem;
}
.intro-about {
	/*max-width: 50rem;*/
	/*margin-bottom: 1rem;*/
	max-width: 60%;
}
.action-bttn {
	margin-top: 3rem;
}
.intro-video-block {
	display: flex;
  	flex-direction: column;
	display: flex;
	position: relative; /* Establishes a positioning context for absolute children */
  	display: inline-block; /* Helps contain the image dimensions */
	/*width: 524px;
	height: 279px; */
	max-width: 35%;
	background-color: grey;
	border-radius: .5rem;
    margin-top: 1rem;
}
.intro-video-block img {
	opacity: 0.5;
}

.section-header {
	color: var(--text-Header, #171717);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	align-self: stretch;
	margin-bottom: 2rem;

	/* Medium/H2 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H2, 3.0625rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H2, 3.75rem); /* 122.449% */

}

.section-description {
	display: flex;
	align-self: stretch;

	color: var(--text-Primary, #2C2C2C);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */

	max-width: 43rem;
	margin-bottom: 2rem;
}

.btn-primary {
	display: inline-block;
	width: 12rem;
	padding: 0.75rem 1rem;
	align-self: stretch;
	text-align: center;
	border-radius: .5rem;
	text-decoration: none;
}
.card-image {
	width: 100%;      /* Image takes the full width of its parent */
	height: 100%;     /* Image takes the full height of its parent */
	object-fit: cover; /* or contain, fill, etc. */
	border-radius: var(--radius-xl, 0.75rem);

	display: flex;
	justify-content: center; /* Centers content horizontally (main axis) */
	align-items: center;   /* Centers content vertically (cross axis) */

}
.video-start {
	display: flex;
	justify-content: center; /* Centers content horizontally (main axis) */
	align-items: center;   /* Centers content vertically (cross axis) */
	height: 279px;

	position: absolute; /* Positions the div relative to its parent container */
	top: 0; /* Aligns to the top edge of the container */
	left: 0; /* Aligns to the left edge of the container */
	width: 100%; /* Makes the overlay cover the full width */
	height: 100%; /* Makes the overlay cover the full height */
	background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
	color: var(--icons-icon-cta-reverse, #FFF);
	/* Optional: center content using flexbox */
	display: flex;
	justify-content: center;
	align-items: center;
	/* Add padding or other styles for better presentation */
	/*padding: 10px;*/
	/*box-sizing: border-box;*/
	border-radius: var(--radius-xl, 0.75rem);
}
.video-icon {
	color: var(--icons-icon-cta-reverse, #FFF);
	text-align: center;
	/*font-family: "Font Awesome 6 Pro";*/
	font-size: 64px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	cursor: pointer;
}
@media (max-width: 1170px) {
	.intro-about {
		max-width: 100%;
		margin-bottom: 2rem;
	}
	.intro-video-block {
		align-items: center;
		justify-content: center;
		max-width: 524px;
	}
}
@media (max-width: 600px) {
	.btn-primary {
		display:block;
		width: 100%;
	}
}

</style>